/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { formatPhoneInput } from '../../lib/utils';

// import * as AppPropTypes from '../../lib/PropTypes';
import TextField from './Text';

import styles from '../../../styles/fields/phone.module.scss';

const propTypes = {
    className: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.object })]),
    value: PropTypes.string,
    onChange: PropTypes.func,
};

const defaultProps = {
    className: null,
    inputRef: null,
    value: null,
    onChange: null,
};

const PhoneField = ({ className, inputRef, onChange, value, ...props }) => {
    const onPhoneFieldChange = useCallback(
        (newValue) => {
            if (onChange !== null) {
                onChange(formatPhoneInput(newValue, value));
            }
        },
        [value, onChange],
    );

    return (
        <TextField
            type="tel"
            inputMode="tel"
            className={classNames([styles.input, { [className]: className !== null }])}
            value={value}
            onChange={onPhoneFieldChange}
            {...props}
        />
    );
};

PhoneField.propTypes = propTypes;
PhoneField.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => <PhoneField inputRef={ref} {...props} />);
